import { InsightData } from 'schemas/action/InsightDataSchema'

export const getPercentShared = (insight: InsightData, totalInsightVal: number) =>
  Math.round((insight.value! / totalInsightVal) * 100)

export const getRoundedPerCapita = (insight: InsightData) => {
  if (+insight.population! === 0) {
    return 0
  }
  const rounded = +insight.perCapita!.toFixed(1)
  if (rounded < 0.1) {
    return 0.1
  }
  return rounded
}

export const getPerCapitaTooltipVal = (insight: InsightData) => {
  if (+insight.population! === 0) {
    return '--'
  }
  if (insight.perCapita! < 0.1) {
    return '< 0.1'
  }
  return insight.perCapita!.toFixed(1)
}

export const getPercentShareTooltipVal = (insight: InsightData, total: number) => {
  const percentShare = insight.value! / total
  if (percentShare < 0.01) {
    return '<1%'
  }
  return `${Math.round(percentShare * 100)}%`
}
